import { Controller } from "@hotwired/stimulus"
import closeOtherDropdowns from "./close_other_dropdowns"

export default class extends Controller {
  static targets = ["button", "dropdown", "reprocessButton", "reprocessButtonText", "message", "messageContent"]

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundHandleClickOutside) // ubs:ignore — disconnect removes this exact stored handler
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    closeOtherDropdowns(this.application, this.element)

    this.dropdownTarget.classList.toggle("hidden")
    const open = !this.dropdownTarget.classList.contains("hidden")
    this.buttonTarget.setAttribute("aria-expanded", open)

    if (open) {
      this.positionDropdown()
      this.dropdownTarget.focus()
    } else {
      this.clearPositioning()
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  close(event) {
    if (this.dropdownTarget.classList.contains("hidden")) return

    this.dropdownTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.clearPositioning()
    if (event?.type === "keydown") this.buttonTarget.focus()
  }

  clearPositioning() {
    this.dropdownTarget.removeAttribute("style")
  }

  positionDropdown() {
    if (window.innerWidth < 640) return

    const button = this.buttonTarget
    const dropdown = this.dropdownTarget
    const buttonRect = button.getBoundingClientRect()
    const dropdownWidth = dropdown.offsetWidth
    const left = Math.min(
      Math.max(8, buttonRect.right - dropdownWidth),
      window.innerWidth - dropdownWidth - 8
    )

    dropdown.style.left = `${left}px`
    dropdown.style.top = `${buttonRect.bottom + 4}px`
    dropdown.style.right = 'auto'
    dropdown.style.bottom = 'auto'

    requestAnimationFrame(() => {
      const dropdownRect = dropdown.getBoundingClientRect()
      if (dropdownRect.bottom > window.innerHeight - 8) {
        dropdown.style.top = `${Math.max(8, buttonRect.top - dropdownRect.height - 4)}px`
      }
    })
  }

  async reprocess(event) {
    event.preventDefault()
    event.stopPropagation()

    const documentId = event.currentTarget.dataset.documentId
    const forceAsInvoice = event.currentTarget.dataset.forceAsInvoice === "true"
    const button = this.reprocessButtonTarget
    const buttonText = this.reprocessButtonTextTarget
    const buttonLabel = forceAsInvoice ? "Priversti apdoroti kaip sąskaitą" : "Bandyti dar kartą"

    this.setLoading(button, buttonText, forceAsInvoice ? "Priverstinai apdorojama..." : "Kartojama...")
    this.hideMessage()

    try {
      const response = await fetch(`/documents/${documentId}/reprocess`, {
        method: 'POST',
        signal: AbortSignal.timeout(30_000),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
          force_as_invoice: forceAsInvoice
        })
      })

      const data = await response.json()

      if (response.ok) {
        this.showMessage(data.message, 'success')
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      } else {
        this.showMessage(data.error || 'Nepavyko pakartotinai apdoroti dokumento', 'error')
        this.resetButton(button, buttonText, buttonLabel)
      }
    } catch (error) {
      this.showMessage('Įvyko klaida. Bandykite dar kartą.', 'error')
      this.resetButton(button, buttonText, buttonLabel)
    }
  }

  setLoading(button, buttonText, text) {
    button.disabled = true
    button.classList.add('opacity-50')
    buttonText.textContent = text
  }

  resetButton(button, buttonText, originalText) {
    button.disabled = false
    button.classList.remove('opacity-50')
    buttonText.textContent = originalText
  }

  showMessage(message, type) {
    const messageContainer = this.messageTarget
    const messageContent = this.messageContentTarget
    const statusRegion = document.getElementById('document-reprocessing-status')
    
    messageContent.textContent = message
    messageContent.className = `p-2 rounded text-xs ${type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`
    
    messageContainer.classList.remove('hidden')

    if (statusRegion) {
      statusRegion.textContent = ''
      requestAnimationFrame(() => {
        statusRegion.textContent = message
      })
    }
  }

  hideMessage() {
    if (this.hasMessageTarget) {
      this.messageTarget.classList.add('hidden')
    }
  }
}
